module.exports = __webpack_public_path__ + "static/img/LeveManfred_TudorDavid_Cage_Water-Music_1960_2.37bca36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/LeveManfred_TudorDavid_Cage_Water-Music_1960_2.jpg
// module id = xVo+
// module chunks = 0